/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.5.1
 */
import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client/index.js';

const tipGroupCss = ":host{box-sizing:border-box;display:block;background-color:var(--calcite-ui-foreground-1);font-size:var(--calcite-font-size--1);line-height:1rem;color:var(--calcite-ui-text-2)}::slotted(calcite-tip){margin:0px;border-style:none;max-inline-size:var(--calcite-tip-max-width)}:host([hidden]){display:none}[hidden]{display:none}";

const TipGroup = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.groupTitle = undefined;
  }
  render() {
    return h("slot", null);
  }
  static get style() { return tipGroupCss; }
}, [1, "calcite-tip-group", {
    "groupTitle": [1, "group-title"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["calcite-tip-group"];
  components.forEach(tagName => { switch (tagName) {
    case "calcite-tip-group":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, TipGroup);
      }
      break;
  } });
}
defineCustomElement$1();

const CalciteTipGroup = TipGroup;
const defineCustomElement = defineCustomElement$1;

export { CalciteTipGroup, defineCustomElement };
